// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PwqX","colMin":"styles_colMin__1HSe6"};